(function () {
  'use strict';

  angular
  .module('filter.format', [])

  /* @ngInject */
  .filter('format', function () {
    return function (value) {
      if (!value) return value;
      if (arguments.length > 1) {
        var str = value;
        for (var i = 1; i < arguments.length; i++) {
          var reg = new RegExp('\\{' + (i - 1) + '\\}');
          str = str.replace(reg, arguments[i]);
        }
        return str;
      }
      return value;
    };
  });

})();
